export default __webpack_public_path__ + "static/media/complement.335ce271.png";